// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__3uJYe"};